import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Grid, Stack, Tooltip, Typography } from '@mui/material';
import {
  deleteCarrerasAction,
  allCarrerasAction,
  setActivoCarrerasAction,
} from '../CarrerasAction';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { LoadingWidget } from '../../../../widgets';
import { Chip } from '@mui/material';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { Box } from '@mui/material';
import { useNotification } from '../../../../helpers/Notification';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoCarreras = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const carrerasStore = Redux.useSelector((state) => state.carreras);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (carrerasStore.all && carrerasStore.all.length === 0) {
        await allCarrerasAction(dispatch, null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = carrerasStore.all.find((el) => el.id === id);
    await setActivoCarrerasAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteCarrerasAction(
      { dispatch, notify },
      carrerasStore.activo.id,
      carrerasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.codigo.name,
      label: CONST.codigo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.link.name,
      label: CONST.link.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                width: '18vw',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              <Links target="_blank" href={value}>
                {value}
              </Links>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.totalEntidades.name,
      label: CONST.totalEntidades.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Chip size="small" label={value ?? 0} />;
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value?.nombre ?? '--'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  const data = carrerasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoCarrerasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  const isEntidades = carrerasStore.activo?.totalEntidades > 0;

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={carrerasStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={carrerasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {carrerasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
          isText={!isEntidades}
          isConfirmBottom={!isEntidades}
        >
          {isEntidades ? (
            <Typography variant="body1">
              No puedes eliminar esta carrera porque tiene entidades relacionada
            </Typography>
          ) : (
            <Typography variant="h6">{carrerasStore.activo.nombre}</Typography>
          )}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoCarreras;
